// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/hnf.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
    size: A4;
    margin: 0; /* Remove default margin for printing */
  }

  
  @media print {
    /* Ensure html and body are visible and take up space */
  
    .SafetyPermit {
      visibility:visible;
      margin-left: 5%;
    }
    button.SafetyPermit-print-button {
      display: none;
    }

    h1, h2, h3, h4,  .SafetyPermit__title-main, .SafetyPermit__title, .stamphehe
    .SafetyPermit__text-justified, .img-2x2inch, .rdsignature, .bottom, .bottom > div {
        visibility: visible;
    }
    
  }

  
  .SafetyPermit {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Path to your image */
    background-size: cover; /* Cover the entire area */
    background-repeat: no-repeat; /* Prevent repeating */
    width: 210mm; /* A4 width */
    height: 297mm; /* A4 height */
    padding: 30mm 20mm; /* Padding for content */
    color: #333;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    position: relative;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  
  h1, h2, h3 {
    margin: 10px 0; /* Margin for headings */
    text-align: center; /* Center text */
    color: #000; /* Text color */
  }

  .SafetyPermit__title-main {
    margin: 10px 0; /* Margin for headings */
    text-align: center; /* Center text */
    color: #000; /* Text color */
    font-family: 'Arial Black', sans-serif; /* Change font for this heading */
  }
  .SafetyPermit__title, 
  .SafetyPermit__text-justified {
    margin: 10px 0; /* Margin for headings */
    color: #000; /* Text color */
  }
  .SafetyPermit__text-justified {
    text-align: justify; /* Justify text */
    text-indent: 50px; /* Indent the first line */
  }

  .img-2x2inch {
    width: 2in;
    height: 2in;
    object-fit: contain; /* preserve aspect ratio, fit inside box */
    display: block;
    border: 2px solid black; /* black border around the image */
    box-sizing: border-box; /* ensure border is included in the size */
  }
  .rdsignature {
    width: auto;
    height: 60px;
    display: block;
  }
  
  .bottom{
    width: 150%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;

  }
  .bottom > div {
    margin: 0 20px; /* Adjust the value as needed for spacing */
  }
  
  button.print-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #3498db;
    color: white;
    border: none;
    padding: 10px 18px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  
  button.print-button:hover {
    background-color: #2980b9;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/SafetyPermit/SafetyPermit.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,SAAS,EAAE,uCAAuC;EACpD;;;EAGA;IACE,uDAAuD;;IAEvD;MACE,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,aAAa;IACf;;IAEA;;QAEI,mBAAmB;IACvB;;EAEF;;;EAGA;IACE,yDAA6C,EAAE,uBAAuB;IACtE,sBAAsB,EAAE,0BAA0B;IAClD,4BAA4B,EAAE,sBAAsB;IACpD,YAAY,EAAE,aAAa;IAC3B,aAAa,EAAE,cAAc;IAC7B,kBAAkB,EAAE,wBAAwB;IAC5C,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,gCAAgC;IACrD,kBAAkB;IAClB,4DAA4D;EAC9D;;;EAGA;IACE,cAAc,EAAE,wBAAwB;IACxC,kBAAkB,EAAE,gBAAgB;IACpC,WAAW,EAAE,eAAe;EAC9B;;EAEA;IACE,cAAc,EAAE,wBAAwB;IACxC,kBAAkB,EAAE,gBAAgB;IACpC,WAAW,EAAE,eAAe;IAC5B,sCAAsC,EAAE,iCAAiC;EAC3E;EACA;;IAEE,cAAc,EAAE,wBAAwB;IACxC,WAAW,EAAE,eAAe;EAC9B;EACA;IACE,mBAAmB,EAAE,iBAAiB;IACtC,iBAAiB,EAAE,0BAA0B;EAC/C;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB,EAAE,0CAA0C;IAC/D,cAAc;IACd,uBAAuB,EAAE,kCAAkC;IAC3D,sBAAsB,EAAE,0CAA0C;EACpE;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;;EAErB;EACA;IACE,cAAc,EAAE,2CAA2C;EAC7D;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;;EAGA;IACE,yBAAyB;EAC3B","sourcesContent":["@page {\r\n    size: A4;\r\n    margin: 0; /* Remove default margin for printing */\r\n  }\r\n\r\n  \r\n  @media print {\r\n    /* Ensure html and body are visible and take up space */\r\n  \r\n    .SafetyPermit {\r\n      visibility:visible;\r\n      margin-left: 5%;\r\n    }\r\n    button.SafetyPermit-print-button {\r\n      display: none;\r\n    }\r\n\r\n    h1, h2, h3, h4,  .SafetyPermit__title-main, .SafetyPermit__title, .stamphehe\r\n    .SafetyPermit__text-justified, .img-2x2inch, .rdsignature, .bottom, .bottom > div {\r\n        visibility: visible;\r\n    }\r\n    \r\n  }\r\n\r\n  \r\n  .SafetyPermit {\r\n    background-image: url('../../Assets/hnf.jpg'); /* Path to your image */\r\n    background-size: cover; /* Cover the entire area */\r\n    background-repeat: no-repeat; /* Prevent repeating */\r\n    width: 210mm; /* A4 width */\r\n    height: 297mm; /* A4 height */\r\n    padding: 30mm 20mm; /* Padding for content */\r\n    color: #333;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Center content vertically */\r\n    align-items: center; /* Center content horizontally */\r\n    position: relative;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  }\r\n\r\n  \r\n  h1, h2, h3 {\r\n    margin: 10px 0; /* Margin for headings */\r\n    text-align: center; /* Center text */\r\n    color: #000; /* Text color */\r\n  }\r\n\r\n  .SafetyPermit__title-main {\r\n    margin: 10px 0; /* Margin for headings */\r\n    text-align: center; /* Center text */\r\n    color: #000; /* Text color */\r\n    font-family: 'Arial Black', sans-serif; /* Change font for this heading */\r\n  }\r\n  .SafetyPermit__title, \r\n  .SafetyPermit__text-justified {\r\n    margin: 10px 0; /* Margin for headings */\r\n    color: #000; /* Text color */\r\n  }\r\n  .SafetyPermit__text-justified {\r\n    text-align: justify; /* Justify text */\r\n    text-indent: 50px; /* Indent the first line */\r\n  }\r\n\r\n  .img-2x2inch {\r\n    width: 2in;\r\n    height: 2in;\r\n    object-fit: contain; /* preserve aspect ratio, fit inside box */\r\n    display: block;\r\n    border: 2px solid black; /* black border around the image */\r\n    box-sizing: border-box; /* ensure border is included in the size */\r\n  }\r\n  .rdsignature {\r\n    width: auto;\r\n    height: 60px;\r\n    display: block;\r\n  }\r\n  \r\n  .bottom{\r\n    width: 150%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n\r\n  }\r\n  .bottom > div {\r\n    margin: 0 20px; /* Adjust the value as needed for spacing */\r\n  }\r\n  \r\n  button.print-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background-color: #3498db;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 18px;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n  \r\n  button.print-button:hover {\r\n    background-color: #2980b9;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
